module.exports = __webpack_public_path__ + "static/media/icon_ceramic_metal_5.a3675978.svg";